<div class="container">
  <h3 class="page-title">Dados paciente</h3>
  <mc-patient-form [patient]="patient" (canceled)="goBack()" (saved)="savePatient()"></mc-patient-form>
</div>
